import { useLayoutEffect, useState } from "react";
import { animated, to, useTransition } from "@react-spring/web";
import { ReactComponent as TicketEdge } from "./icons/ticket-edge.svg";

import "./Ticket.css";

const transform = (r, s) => `perspective(1500px) rotateX(10deg) rotateY(${r}deg) scale(${s})`;
function generateTicketNumber(str) {
	let hash = 0;
	if (str.length === 0) return hash;
	for (let i = 0; i < str.length; i++) {
		const chr = str.charCodeAt(i);
		hash = ((hash << 5) - hash) + chr;
		hash |= 0; // Convert to 32bit integer
	}
	return `${Math.abs(hash)}`.slice(-4).padStart(4, "0");
}

const Ticket = ({ title }) => {
	const [ticketStack, setTicketStack] = useState([]);
	useLayoutEffect(() => setTicketStack((ticketStack) => [...ticketStack, title].slice(-10)), [title]);
	const transitions = useTransition(ticketStack, {
		from: { x: 0, y: -1000, scale: 1.5, rot: 0 },
		enter: (item) => {
			const i = ticketStack.indexOf(item);
			return { x: 0, y: i * -4, scale: 1, rot: -10 + Math.random() * 20 };
		},
		leave: { scale: 0 },
		delay: 100,
	});

	return (
		<>
			<TicketEdge /* SVG Def */ />
			{transitions(({ x, y, rot, scale }, ticket) => (
        <animated.div key={ticket} className="event-outer" style={{ transform: to([x, y], (x, y) => `translate3d(${x}px,${y}px,0)`) }}>
					<animated.div
						className="event"
						style={{
							transform: to([rot, scale], transform)
						}}
					>
						<div className="event-side">
							<div className="event-number">
								JIRA-{generateTicketNumber(ticket)}
							</div>
							<div className="dotted-line-separator">
								<span className="line" />
							</div>
						</div>
						<div className="event-body">
							<div className="event-image">
								<span className="image" />
							</div>
							<div className="event-title">
								<h3>{ticket}</h3>
							</div>
						</div>
					</animated.div>
				</animated.div>
      ))}
		</>
	);
};

export default Ticket;
